import React from "react";
//#region types
import { ProjectStatusTagsProps } from "models/propTypes/timeReportingProjectPropTypes";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { Tags } from "components/common";
import { TranslationKeys } from "translations";
//#endregion
//#region components
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ProjectStatusTags: React.FC<ProjectStatusTagsProps> = (props) => {
  const { projectActiveState } = props;
  const getLabelClass = (projectActiveState: ApiModel.ProjectActiveState) => {
    if (projectActiveState === ApiModel.ProjectActiveState.Active) {
      return cssExports.greenTag;
    } else if (projectActiveState === ApiModel.ProjectActiveState.Inactive) {
      return cssExports.blueTag;
    } else {
      return cssExports.grayTag;
    }
  };

  const getLabel = (projectActiveState: ApiModel.ProjectActiveState) => {
    if (projectActiveState === ApiModel.ProjectActiveState.Deleted) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectIsDeleted);
    } else if (projectActiveState === ApiModel.ProjectActiveState.Inactive) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectIsInActive);
    } else if (projectActiveState === ApiModel.ProjectActiveState.NotStarted) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectIsNotStarted);
    }
    return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectIsActive);
  };

  return <Tags tags={[getLabel(projectActiveState)]} className={getLabelClass(projectActiveState)} />;
};

export default ProjectStatusTags;
